// extracted by mini-css-extract-plugin
module.exports = {"container":"_37tIXIoaOYF0ocDvaiUPkb","heading":"_1_tljkcjJwQtnxSHZbxg8e","link--fi":"_3KsWTaB01Hfv4k9Z5-xtz0","link--se":"_2UxVhkVEO0Iq-oUWFOYggZ"};